import { format, parseISO, isToday, isYesterday, formatDistanceToNow } from 'date-fns'
import { ru } from 'date-fns/locale'

export function formatNewsDate(dateString: string): string {
  const date = parseISO(dateString)
  const time = format(date, 'HH:mm')

  if (isToday(date)) {
    return `Сегодня ${time}`
  }

  if (isYesterday(date)) {
    return `Вчера ${time}`
  }

  return format(date, 'dd.MM.yyyy HH:mm', { locale: ru })
}

export function formatEventDate(
  dateString?: string,
  startTime?: string,
  endTime?: string
): { date: string, time: string } {
  if (!dateString || !startTime) return { date: '', time: '' }

  const startDateTimeString = `${dateString}T${startTime}`
  const startDate = parseISO(startDateTimeString)

  const datePart = format(startDate, 'd MMMM', { locale: ru })
  let timePart = format(startDate, 'HH:mm', { locale: ru })

  if (endTime) {
    const endDateTimeString = `${dateString}T${endTime}`
    const endDate = parseISO(endDateTimeString)
    timePart += ` - ${format(endDate, 'HH:mm', { locale: ru })}`
  }

  return {
    date: datePart,
    time: timePart
  }
}

export function calculateAgeAndBirthday(birthday: string | undefined): string {
  if (!birthday) return ""

  try {
    const birthDate = new Date(birthday)
    if (isNaN(birthDate.getTime())) return birthday

    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }

    let yearsText = "лет";
    if (age % 100 < 10 || age % 100 > 20) {
      switch (age % 10) {
        case 1: yearsText = "год"; break
        case 2:
        case 3:
        case 4: yearsText = "года"; break
      }
    }

    const day = String(birthDate.getDate()).padStart(2, '0')
    const month = String(birthDate.getMonth() + 1).padStart(2, '0')
    const formattedBirthday = `${day}.${month}.${birthDate.getFullYear()}`

    return `${age} ${yearsText} · ${formattedBirthday}`
  } catch {
    return birthday
  }
}

export function formatDateToDDMMYYYY(dateString: string) {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    console.error("Invalid date string!");
    return "Invalid date";
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}
